import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class CoreRouteReuseStrategy extends BaseRouteReuseStrategy {
  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.data.reuseRoute ?? future.routeConfig === curr.routeConfig;
  }
}
